import { useMemo, useState } from "react";
import { ServiceObjectsServiceObjectRevisionCategory } from "../../../../api/models/unified";
import { Column } from "react-data-grid";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { useNextRevisionHelpers } from "../../../../helpers/serviceObjectHelper";
import { Table, Title } from "../../../../components";
import { TableQuery, TableSortQuery } from "../../../../common/models";
import {
  defaultTableQuery,
  getSortedTableData,
  getTableDataByPage,
  getTablePageCount,
} from "../../../../helpers/tableHelpers";

interface ServiceObjectNextRevisionsProps {
  nextRevisionCategories: ServiceObjectsServiceObjectRevisionCategory[];
}

const ServiceObjectNextRevisions = ({
  nextRevisionCategories,
}: ServiceObjectNextRevisionsProps) => {
  const { tServiceObject } = useCustomTranslation();
  const [queryParams, setQueryParams] = useState<TableQuery>(defaultTableQuery);
  const getSortedRevisionData = getSortedTableData as (
    data: ServiceObjectsServiceObjectRevisionCategory[],
    query: TableSortQuery,
  ) => ServiceObjectsServiceObjectRevisionCategory[];

  const { translateRevisionPeriod } = useNextRevisionHelpers();

  const columns = useMemo<
    Column<ServiceObjectsServiceObjectRevisionCategory>[]
  >(
    () => [
      {
        key: "name",
        name: tServiceObject("revision_category"),
        sortable: true,
      },
      {
        key: "nextRevision",
        name: tServiceObject("next_revision"),
        renderCell: ({ row }) =>
          row.nextRevision ? renderDate(row.nextRevision) : "-",
        sortable: true,
      },
      {
        key: "nextRevisionPeriod",
        name: tServiceObject("revision_period"),
        renderCell: ({ row }) =>
          row.nextRevisionPeriodUnit && row.nextRevisionPeriodValue
            ? translateRevisionPeriod(
                row.nextRevisionPeriodValue,
                row.nextRevisionPeriodUnit,
              )
            : "-",
      },
    ],
    [tServiceObject, translateRevisionPeriod],
  );

  const sortedData = useMemo<ServiceObjectsServiceObjectRevisionCategory[]>(
    () => getSortedRevisionData(nextRevisionCategories, queryParams),
    [getSortedRevisionData, nextRevisionCategories, queryParams],
  );

  return (
    <div className="mt-14">
      <Title className="mb-2.5 ml-5" title={tServiceObject("revision")} />
      <Table
        columns={columns}
        data={getTableDataByPage(queryParams, sortedData)}
        queryParams={queryParams}
        onTableQueryChange={setQueryParams}
        pageCount={getTablePageCount(sortedData.length, queryParams.pageSize)}
        detailMode
      />
    </div>
  );
};

export default ServiceObjectNextRevisions;
